import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { t } from '../../utils/localization/localization';
import { ErrorState } from '../common';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper
} from '@mui/material';

export default function Login() {
  const [error, setError] = useState('');
  const { startOidcLogin } = useAuth();

  useEffect(() => {
    // Auto-start OIDC flow when the user hits /login (tests expect redirect).
    (async () => {
      try {
        await startOidcLogin();
      } catch (e) {
        setError(e?.message || 'oidc_login_failed');
      }
    })();
  }, [startOidcLogin]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            {t('auth.loginTitle')}
          </Typography>

          {error && (
            <Box sx={{ mb: 2 }}>
              <ErrorState
                error={error}
                title={t('auth.loginError', 'Login Failed')}
                context="User authentication"
                severity="error"
                showIcon={true}
                component="Login-Error"
                onRetry={() => setError('')}
                retryText={t('common.dismiss', 'Dismiss')}
              />
            </Box>
          )}

          <Box sx={{ mt: 2 }}>
            <Button fullWidth variant="contained" onClick={() => startOidcLogin()}>
              {t('auth.login', 'Sign in')}
            </Button>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
              <Link to="/" style={{ textDecoration: 'none' }}>
                {t('common.back', 'Back')}
              </Link>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
